import { useEffect, useState } from "react";
import { Loader2, LogIn } from "lucide-react";
import { api, setAuthToken, formatApiError } from "@/api/client";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function DevLoginsPage() {
  const [accounts, setAccounts] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    api.get("/dev/logins").then((r) => setAccounts(r.data)).catch(() => setAccounts(false));
  }, []);

  const signIn = async (email) => {
    setBusy(email);
    try {
      const { data } = await api.post("/dev/login", { email });
      setAuthToken(data.access_token);
      window.location.href = "/";
    } catch (err) {
      toast.error(formatApiError(err));
      setBusy("");
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10 sm:py-16" data-testid="dev-logins-page">
      <div className="max-w-xl mx-auto">
        <div className="text-xs uppercase tracking-[0.2em] text-slate-500">CrewOnShip · Test site</div>
        <h1 className="text-3xl font-bold text-[#0b192c] mt-1">Dev logins</h1>
        <p className="text-sm text-slate-600 mt-2">One-tap sign-in for test accounts. Not available on the published app.</p>
        {accounts === null && <Loader2 className="w-5 h-5 animate-spin mt-8 text-slate-400" data-testid="dev-logins-loading" />}
        {accounts === false && <div className="mt-8 rounded-lg border border-slate-200 bg-white p-5 text-sm text-slate-600" data-testid="dev-logins-unavailable">This page is not available here.</div>}
        {accounts && (
          <ul className="mt-8 divide-y divide-slate-100 rounded-xl border border-slate-200 bg-white" data-testid="dev-logins-list">
            {accounts.map((a) => (
              <li key={a.email} className="flex items-center justify-between gap-3 px-4 py-3.5" data-testid={`dev-login-row-${a.email}`}>
                <div className="min-w-0">
                  <div className="font-semibold text-slate-800">{a.role}</div>
                  <div className="text-sm text-slate-500 truncate font-mono">{a.email}</div>
                </div>
                <Button onClick={() => signIn(a.email)} disabled={!!busy} className="bg-[#0b192c] hover:bg-[#0f2544] shrink-0" data-testid={`dev-login-btn-${a.email}`}>
                  {busy === a.email ? <Loader2 className="w-4 h-4 animate-spin" /> : <><LogIn className="w-4 h-4 mr-1.5" />Sign in</>}
                </Button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
